import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IExamen } from '@app/database/models/IExamen.model';
import { FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Examen } from '@shared/forms/templates/exams-config/Examen.config';
import moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { AsideService } from '@shared/components/aside/aside.service';
import { MessageAlertService } from '@shared/views/_messagesService/_messageAlertServices';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { ExamsConfigService } from '@shared/forms/templates/exams-config/exams-config.service';
import { DatabaseService } from '@app/database/database.service';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { GroupHTemplateService } from '@shared/forms/templates/group-h-template/group-h-template.service';
import { Title } from '@angular/platform-browser';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { IEspecialidades } from '@app/database/models/IEspecialidades.model';

@Component({
  selector: 'app-group-h-template',
  templateUrl: './group-h-template.component.html',
  styleUrls: ['./group-h-template.component.scss']
})
export class GroupHTemplateComponent implements OnInit, OnDestroy {

  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  @Input() examen: any; // IExamen;
  submitted = false;
  imcValidationTriggered = false;
  public examForm: FormGroup;
  seniority = 0;
  unidadTiempo = '';
  maxDate = new Date();
  maxDateIngreso = new Date();
  minDate: any;
  asideObservable: Subscription;
  pesoSubscription!: Subscription;
  tallaSubscription!: Subscription;
  displayAgentes = false;
  invalidField = true;
  configForm: Examen;
  tiposDictamen: any[] = [];
  especialidades: IEspecialidades[];
  attachedFiles: any = {
    data: [],
    invalid: false,
    isEmpty: true,
    attachedFilesValidQuantity: 0
  };
  enviandose = false;
  isOnline = true;
  displayModalFirma = false;
  medicoFirmaB64;
  medicoFirmaSigString;
  cuadroVaricesInvalid = true;
  enableTableVarices = false;
  unidadesTiempoTabaquismo = [
    { label: 'Semanas', value: 'Semanas' },
    { label: 'Meses', value: 'Meses' },
    { label: 'Años', value: 'Años' }
  ];

  constructor(private router: Router,
    private confirmationService: ConfirmationService,
    private asideService: AsideService,
    private titleService: Title,
    private groupHTemplateService: GroupHTemplateService,
    private messageAlertServices: MessageAlertService,
    private backgroundSyncService: BackgroundSyncService,
    private examConfigService: ExamsConfigService,
    private databaseService: DatabaseService,
    private connectionService: ConnectionService) {
  }

  get f(): any {
    return this.examForm.controls;
  }

  ngOnDestroy(): void {
    if (this.asideObservable) {
      this.asideObservable.unsubscribe();
    }
    if (this.pesoSubscription) {
      this.pesoSubscription.unsubscribe();
    }
    if (this.tallaSubscription) {
      this.tallaSubscription.unsubscribe();
    }
    this.asideService.setInsideExamen(false);
    this.titleService.setTitle('Provincia ART ML Offline');
  }

  ngOnInit(): void {
    this.titleService.setTitle('Provincia ART ML Offline');

    this.connectionService.monitor().subscribe((connected: ConnectionState) => {
      this.isOnline = connected.hasNetworkConnection;
    })
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));

    this.cargarFormulario();
    this.calcularAntiguedad();
    this.getTiposDictamen();
    this.getEspecialidades();
    this.minDate = new Date(moment(this.examen.fechaAsignacion).format());
    this.asideObservable = this.asideService.openModalSubject$.subscribe(
      (data) => {
        this.goBack(data);
      }
    );
    this.asideService.setInsideExamen(true);
    this.setupImcClearListeners();
  }

  cargarFormulario() {
    let codigoTipoExamen = (this.examen.tipoEstudio.codigo !== undefined)
      ? this.examen.tipoEstudio.tipoEstudioCod
      : this.examen.tipoEstudio;
    this.configForm = this.examConfigService.getConfig(codigoTipoExamen);
    this.configForm.name = this.examen.provinciaNombreEstudio;
    this.examForm = this.configForm.examForm;
    this.examen.trabajador.apellidoNombre ? this.examForm.controls.apellidoNombre.setValue(this.examen.trabajador.apellidoNombre) : null;
    this.examen.trabajador.fechaNacimiento ? this.examForm.controls.fechaNacimiento.setValue(new Date(moment(this.examen.trabajador.fechaNacimiento).format())) : null;
    this.calculateAge();
    this.examen.puestoTrabajador ?
      this.examForm.controls.puestoTrabajador.setValue(this.examen.puestoTrabajador) : null;
    this.examen.antiguedadPuestoTrabajador ?
      this.examForm.controls.antiguedadPuestoTrabajador.setValue(this._standarizeDate(this.examen.antiguedadPuestoTrabajador)) : null;
    this.examen.fechaIngresoEmpresa ?
      this.examForm.controls.fechaIngresoEmpresa.setValue(new Date(moment(this.examen.fechaIngresoEmpresa).format())) : null;
    this.restrictDateIngresoEmpresa();
    this.medicoFirmaB64 = this.examen.medicoFirmaB64;
    this.medicoFirmaSigString = this.examen.medicoFirmaSigString;
    if (this.examen?.modoVista === "edit" || this.examen.modoVista === 'ver' || this.examen?.cargadoOffline) {
      this.setValuesOnFormOnVerOrEditMode();
    } else {
      this.examen.antecedentesVarices = this.examForm.controls.antecedentesVarices.value;
      this.examen.varicocele = this.examForm.controls.varicocele.value;
      this.examen.hemorroides = this.examForm.controls.hemorroides.value;
      this.validateCheckboxItems();
    }
  }

  _standarizeDate(date: any) {
    let splitedDate = date.replace(/\//g, '-');
    const dateParts = splitedDate.split('-');
    if (date.includes('/')) {
      return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
    } else {
      return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
    }
  }

  /**
   * Metodo que se encarga de obtener los tipos de dictamen
   */
  async getTiposDictamen(): Promise<void> {
    const dataFromOffline = await this.databaseService.getAllTiposDictamenFromOfflineDB();
    this.tiposDictamen = dataFromOffline.filter(
      (x) => x.codigo === 'A' || x.codigo === 'I' || x.codigo === 'N'
    );
  }

  // ESPECIALIDADES
  async getEspecialidades(): Promise<void> {
    const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
    this.especialidades = especialidadesListFromOffline;
  }


  /**
   * Metodo que se encarga de calcular la antiguedad del trabajador (en meses o años)
   */
  calcularAntiguedad() {
    if (this.examen.fechaAltaEmpleado) {
      this.seniority = moment().diff(
        moment(this.examen.fechaAltaEmpleado),
        'years'
      );
      if (this.seniority > 1) {
        this.unidadTiempo = 'años';
      } else if (this.seniority < 1) {
        this.seniority = moment().diff(
          moment(this.examen.fechaAltaEmpleado),
          'months'
        );
        if (this.seniority > 1) {
          this.unidadTiempo = 'meses';
        } else {
          this.unidadTiempo = 'mes';
        }
      } else {
        this.unidadTiempo = 'año';
      }
    }
  }

  /**
   * Metodo que se encarga
   * @param ruta
   */
  goBack(ruta?) {
    if (this.examForm.dirty) {
      this.confirm(ruta);
    } else {
      this.returnToExams(ruta);
    }
  }

  /**
   * Metodo que se encarga de abrir el modal y redirigir a la pagina de la ruta que recibe
   * @param ruta ruta para redirigir
   */
  confirm(ruta?) {
    this.confirmationService.confirm({
      header: `¿Está seguro de que desea cancelar la carga del estudio?`,
      message: `Si cancela el estudio ahora perderá toda la información cargada hasta el momento`,
      key: 'goBackFormEC',
      accept: () => {
        this.returnToExams(ruta);
      },
    });
  }

  returnToExams(ruta?) {
    this.router.navigate([ruta ? ruta : 'examenes']);
  }

  buildUrlApi(method: string): string {
    return `${environment.apiUrl}` + method;
  }

  buildRequest() {
    let examFormData = { ...this.examForm.getRawValue() };
    examFormData.userId = this.currentUser.userId;
    examFormData.username = this.currentUser.username;
    examFormData.modelId = this.currentUser.modelId;
    examFormData.tipoEstudio = this.configForm.code;
    examFormData.examenNumero = this.examen.id;
    examFormData.medicoMatricula = examFormData.matricula;
    examFormData.fechaRealizacion = moment(examFormData.fechaRealizacion).format(
      'yyyy-MM-DD'
    );
    examFormData.fechaIngresoEmpresa = moment(examFormData.fechaIngresoEmpresa).format(
      'yyyy-MM-DD'
    );
    examFormData.antiguedadPuestoTrabajador = moment(examFormData.antiguedadPuestoTrabajador).format('yyyy-MM-DD');
    this.examen?.modoVista === "edit" ? examFormData.esEdicion = !!(this.examen?.modoVista === "edit" && this.isOnline) : null;
    examFormData.adjuntos = this.attachedFiles.data;
    examFormData.medicoFirmaB64 = this.medicoFirmaB64;
    examFormData.medicoFirmaSigString = this.medicoFirmaSigString;
    examFormData.fumador = this.examForm.controls.fumador.value ? "SI" : this.examForm.controls.noFumador.value ? "NO" : "EX";
    if(this.examForm.controls.fumador.value || this.examForm.controls.exFumador.value) {
      examFormData.cantidadCigarrillos = this.examForm.controls.fumaUnoDiez.value ? "1a10" : this.examForm.controls.fumaOnceVeinte.value ? "11a20" : "Más20";
    }
  
		examFormData = this.evaluateChangeTrabajador(examFormData);

		return examFormData;
	}

	private evaluateChangeTrabajador(object) {
		if (this.examen.seModificoTrabajador 
			|| this.examen.trabajador.fechaNacimiento != moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			|| this.examen.trabajador.apellidoNombre != this.examForm.controls.apellidoNombre.value) {

			object.trabajador = {
				apellidoNombre: this.examForm.controls.apellidoNombre.value,
				fechaNacimiento: moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			};
			this.examen.seModificoTrabajador = true;
		}
		return object;
	}

  capitalize(word: string) {
    if (!word) {
      return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }
  
  /**
   * función que recibe el trigger desde el componente attach-upload-file
   * con el objeto actualizado de la lista de archivos y errores
   * @param  {object} event
   * @example:
   *  {
   *    errors: {
   *      isSizeValid: false
   *      isTypeValid: false,
   *    },
   *    data: [
   *       {
   *        archivoBase64: todounstringpegado,
   *        nombreOriginal: "example.png",
   *        tipo: "png",
   *        size: 121354,
   *        esAlta:false,
   *        esBaja:false
   *    ],
   *    invalid: false,
   *    isEmpty: true,
   *    attachedFilesValidQuantity: 0
   *  }
   */
  getAttachedFiles(event: any): any {
    const { errors } = event;

    this.attachedFiles = event;
    if (errors.isSizeValid && errors.isTypeValid) {
      // asigno la data al objeto para enviar
      return false;
    }
  }

  setupImcClearListeners(): void {
    // Limpiar el IMC cuando cambia el peso
    this.pesoSubscription = this.examForm.controls.peso.valueChanges.subscribe(() => {
      this.examForm.controls.indiceMasaCorporal.setValue(null);
      this.imcValidationTriggered = false;
    });

    // Limpiar el IMC cuando cambia la talla
    this.tallaSubscription = this.examForm.controls.talla.valueChanges.subscribe(() => {
      this.examForm.controls.indiceMasaCorporal.setValue(null);
      this.imcValidationTriggered = false;
    });
  }

  calcularImc() {
    // Activar la validación del IMC
    this.imcValidationTriggered = true;
    
    const peso = this.examForm.controls.peso.value;
    const talla = this.examForm.controls.talla.value;

    if (!peso || !talla) {
      this.examForm.controls.indiceMasaCorporal.setValue(null);
      return;
    }
    
    const pesoValido = peso >= 40 && peso <= 180;
    const tallaValida = talla >= 100 && talla <= 220;

    if (!pesoValido || !tallaValida) {
      this.examForm.controls.indiceMasaCorporal.setValue(null);
      return;
    }

    //Cálculo del IMC
    const tallaEnMetros = talla / 100;
    let imc = peso / (tallaEnMetros * tallaEnMetros);
    imc = Math.round(imc);

    this.examForm.controls.indiceMasaCorporal.setValue(imc);
  }

  limpiarCuadroVarices() {
    let camposVarices = Array.from(document.getElementsByClassName("tableVarices"));
    camposVarices.forEach(campo => {
      this.examForm.controls[campo.attributes["formControlName"].value].setValue(false);
    });
  }

  validateCheckboxItems(): void {
    if ((!this.examForm.controls.bipedestacionEstatica.value && !this.examForm.controls.bipedestacionRestringida.value
    && !this.examForm.controls.bipedestacionCarga.value && !this.examForm.controls.bipedestacionExposicion.value
    && !this.examForm.controls.sintomasPrevio2014.value && !this.examForm.controls.bipedestacionNingunaAnteriores.value) || 
    (!this.examForm.controls.fumador.value && !this.examForm.controls.noFumador.value
    && !this.examForm.controls.exFumador.value) || ((this.examForm.controls.fumador.value || this.examForm.controls.exFumador.value)
    && !this.examForm.controls.fumaUnoDiez.value && !this.examForm.controls.fumaOnceVeinte.value && !this.examForm.controls.fumaMasVeinte.value)) {
      this.invalidField = true;
    } else {
      this.invalidField = false;
    }
  }

  clickCheckBox(valor, event) {
    switch (valor) {
      case 'ningunaAnteriores':
        this.examForm.controls.sintomasPrevio2014.setValue(false);
        this.examForm.controls.bipedestacionCarga.setValue(false);
        this.examForm.controls.bipedestacionEstatica.setValue(false);
        this.examForm.controls.bipedestacionExposicion.setValue(false);
        this.examForm.controls.bipedestacionRestringida.setValue(false);
        break;
      case 'noFumador':
        this.examForm.controls.fumador.setValue(false);
        this.examForm.controls.exFumador.setValue(false);
        this.seccionTabaquismo(false);
        break;
      case 'fumador':
        this.examForm.controls.noFumador.setValue(false);
        this.examForm.controls.exFumador.setValue(false);
        this.seccionTabaquismo(event.checked);
        break;
      case 'exFumador':
        this.examForm.controls.fumador.setValue(false);
        this.examForm.controls.noFumador.setValue(false);
        this.seccionTabaquismo(event.checked);
        break;
      case 'fumaUnoDiez':
        this.examForm.controls.fumaOnceVeinte.setValue(false);
        this.examForm.controls.fumaMasVeinte.setValue(false);
        break;
      case 'fumaOnceVeinte':
        this.examForm.controls.fumaUnoDiez.setValue(false);
        this.examForm.controls.fumaMasVeinte.setValue(false);
        break;
      case 'fumaMasVeinte':
        this.examForm.controls.fumaOnceVeinte.setValue(false);
        this.examForm.controls.fumaUnoDiez.setValue(false);
        break;
      case 'varicesOperada':
        if (event.checked) {
          this.examForm.controls.antecedentesVaricesAnio.enable();
          this.examForm.controls.antecedentesVaricesAnio.setValidators(Validators.required);
        } else {
          this.examForm.controls.antecedentesVaricesAnio.disable();
          this.examForm.controls.antecedentesVaricesAnio.setValue(null);
          this.examForm.controls.antecedentesVaricesAnio.setValidators(null);
        }
        this.examForm.controls.antecedentesVaricesAnio.updateValueAndValidity();
        break;
      case 'varicoceleOperada':
        if (event.checked) {
          this.examForm.controls.varicoceleAnio.enable();
          this.examForm.controls.varicoceleAnio.setValidators(Validators.required);
        } else {
          this.examForm.controls.varicoceleAnio.disable();
          this.examForm.controls.varicoceleAnio.setValue(null);
          this.examForm.controls.varicoceleAnio.setValidators(null);
        }
        this.examForm.controls.varicoceleAnio.updateValueAndValidity();
        break;
      case 'hemorroidesOperada':
        if (event.checked) {
          this.examForm.controls.hemorroidesAnio.enable();
          this.examForm.controls.hemorroidesAnio.setValidators(Validators.required);
        } else {
          this.examForm.controls.hemorroidesAnio.disable();
          this.examForm.controls.hemorroidesAnio.setValue(null);
          this.examForm.controls.hemorroidesAnio.setValidators(null);
        }
        this.examForm.controls.hemorroidesAnio.updateValueAndValidity();
        break;
    }
  }

  seccionTabaquismo(checked): void {
    if (checked) {
      this.examForm.controls.fumaUnoDiez.enable();
      this.examForm.controls.fumaOnceVeinte.enable();
      this.examForm.controls.fumaMasVeinte.enable();
      this.examForm.controls.cantidadTiempoFumando.enable();
      this.examForm.controls.unidadTiempoFumando.enable();
      this.examForm.controls.cantidadTiempoFumando.setValidators(Validators.required);
      this.examForm.controls.unidadTiempoFumando.setValidators(Validators.required);
    } else {
      this.examForm.controls.fumaUnoDiez.disable();
      this.examForm.controls.fumaOnceVeinte.disable();
      this.examForm.controls.fumaMasVeinte.disable();
      this.examForm.controls.cantidadTiempoFumando.disable();
      this.examForm.controls.unidadTiempoFumando.disable();
      this.examForm.controls.fumaUnoDiez.setValue(false);
      this.examForm.controls.fumaOnceVeinte.setValue(false);
      this.examForm.controls.fumaMasVeinte.setValue(false);
      this.examForm.controls.cantidadTiempoFumando.setValue(null);
      this.examForm.controls.unidadTiempoFumando.setValue(null);
      this.examForm.controls.cantidadTiempoFumando.setValidators(null);
      this.examForm.controls.unidadTiempoFumando.setValidators(null);
    }
    this.examForm.controls.cantidadTiempoFumando.updateValueAndValidity();
    this.examForm.controls.unidadTiempoFumando.updateValueAndValidity();
  }

  clickRadioButton(event, campo) {
    switch (campo) {
      case 'CARDIOVASCULARES':
        this.habilitarCampo(event, 'afeccionesCardiovascularesDescripcion');
        break;
      case 'METABOLICAS':
        this.habilitarCampo(event, 'afeccionesMetabolicasDescripcion');
        break;
      case 'VARICES':
        if (event === 'NO') {
          this.examForm.controls.antecedentesVaricesOperada.disable();
          this.examForm.controls.antecedentesVaricesOperada.setValue(false);
          this.examForm.controls.antecedentesVaricesAnio.disable();
          this.examForm.controls.antecedentesVaricesAnio.setValue('');
          this.examForm.controls.antecedentesVaricesAnio.setValidators(null);
          this.examForm.controls.antecedentesVaricesAnio.updateValueAndValidity();
        } else {
          this.examForm.controls.antecedentesVaricesOperada.enable();
        }
        break;
      case 'VARICOCELE':
        if (event === 'NO') {
          this.examForm.controls.varicoceleOperada.disable();
          this.examForm.controls.varicoceleOperada.setValue(false);
          this.examForm.controls.varicoceleAnio.disable();
          this.examForm.controls.varicoceleAnio.setValue('');
          this.examForm.controls.varicoceleAnio.setValidators(null);
          this.examForm.controls.varicoceleAnio.updateValueAndValidity();
        } else {
          this.examForm.controls.varicoceleOperada.enable();
        }
        break;
      case 'HEMORROIDES':
        if (event === 'NO') {
          this.examForm.controls.hemorroidesOperada.disable();
          this.examForm.controls.hemorroidesOperada.setValue(false);
          this.examForm.controls.hemorroidesAnio.disable();
          this.examForm.controls.hemorroidesAnio.setValue('');
          this.examForm.controls.hemorroidesAnio.setValidators(null);
          this.examForm.controls.hemorroidesAnio.updateValueAndValidity();
        } else {
          this.examForm.controls.hemorroidesOperada.enable();
        }
        break;
    }
  }

  habilitarCampo(event, field): void {
    if (event === 'NO' || !event ) {
      this.examForm.controls[field].disable();
      this.examForm.controls[field].setValue('');
      this.examForm.controls[field].setValidators(null);
    } else {
      this.examForm.controls[field].enable();
      this.examForm.controls[field].setValidators([
        Validators.required,
        Validators.maxLength(250),
      ]);
    }
    this.examForm.controls[field].updateValueAndValidity();
  }

  clickTableVarices(valor, checked) {
    if(checked) {
      switch (valor) {
        case 'c0mizq':
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c0mder':
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c0bilateral':
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c0asintomatico':
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c0sintomatico':
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c1mizq':
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c1mder':
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c1bilateral':
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c1asintomatico':
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c1sintomatico':
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c2mizq':
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c2mder':
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c2bilateral':
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c2asintomatico':
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c2sintomatico':
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c3mizq':
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c3mder':
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c3bilateral':
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c3asintomatico':
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c3sintomatico':
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c4amizq':
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c4amder':
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c4abilateral':
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c4aasintomatico':
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c4asintomatico':
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c4bmizq':
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c4bmder':
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c4bbilateral':
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c4basintomatico':
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c4bsintomatico':
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c5mizq':
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          break;
        case 'c5mder':
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c6mder.setValue(false);
          break;
        case 'c5bilateral':
          this.examForm.controls.c5mder.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          break;
        case 'c5asintomatico':
          this.examForm.controls.c5sintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c6asintomatico.setValue(false);
          break;
        case 'c5sintomatico':
          this.examForm.controls.c5asintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c6sintomatico.setValue(false);
          break;
        case 'c6mizq':
          this.examForm.controls.c6mder.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          this.examForm.controls.c0mizq.setValue(false);
          this.examForm.controls.c1mizq.setValue(false);
          this.examForm.controls.c2mizq.setValue(false);
          this.examForm.controls.c3mizq.setValue(false);
          this.examForm.controls.c4amizq.setValue(false);
          this.examForm.controls.c4bmizq.setValue(false);
          this.examForm.controls.c5mizq.setValue(false);
          break;
        case 'c6mder':
          this.examForm.controls.c6mizq.setValue(false);
          this.examForm.controls.c6bilateral.setValue(false);
          this.examForm.controls.c0mder.setValue(false);
          this.examForm.controls.c1mder.setValue(false);
          this.examForm.controls.c2mder.setValue(false);
          this.examForm.controls.c3mder.setValue(false);
          this.examForm.controls.c4amder.setValue(false);
          this.examForm.controls.c4bmder.setValue(false);
          this.examForm.controls.c5mder.setValue(false);
          break;
        case 'c6bilateral':
          this.examForm.controls.c6mder.setValue(false);
          this.examForm.controls.c6mizq.setValue(false);
          this.examForm.controls.c0bilateral.setValue(false);
          this.examForm.controls.c1bilateral.setValue(false);
          this.examForm.controls.c2bilateral.setValue(false);
          this.examForm.controls.c3bilateral.setValue(false);
          this.examForm.controls.c4abilateral.setValue(false);
          this.examForm.controls.c4bbilateral.setValue(false);
          this.examForm.controls.c5bilateral.setValue(false);
          break;
        case 'c6asintomatico':
          this.examForm.controls.c6sintomatico.setValue(false);
          this.examForm.controls.c0asintomatico.setValue(false);
          this.examForm.controls.c1asintomatico.setValue(false);
          this.examForm.controls.c2asintomatico.setValue(false);
          this.examForm.controls.c3asintomatico.setValue(false);
          this.examForm.controls.c4aasintomatico.setValue(false);
          this.examForm.controls.c4basintomatico.setValue(false);
          this.examForm.controls.c5asintomatico.setValue(false);
          break;
        case 'c6sintomatico':
          this.examForm.controls.c6asintomatico.setValue(false);
          this.examForm.controls.c0sintomatico.setValue(false);
          this.examForm.controls.c1sintomatico.setValue(false);
          this.examForm.controls.c2sintomatico.setValue(false);
          this.examForm.controls.c3sintomatico.setValue(false);
          this.examForm.controls.c4asintomatico.setValue(false);
          this.examForm.controls.c4bsintomatico.setValue(false);
          this.examForm.controls.c5sintomatico.setValue(false);
          break;
      }
    }
    this.validateCuadroVarices();
  }

  validateCuadroVarices() {
    let countCheckCuadroVarices = 0;
    let camposVarices = Array.from(document.getElementsByClassName("tableVarices"));
    camposVarices.forEach(campo => {
      this.examForm.controls[campo.attributes["formControlName"].value].value ? countCheckCuadroVarices ++ : null;
    });
    countCheckCuadroVarices > 0 ? this.cuadroVaricesInvalid = false : this.cuadroVaricesInvalid = true;
  }

  private saveToOnline(): void {
    this.groupHTemplateService.loadExam(this.buildRequest(), this.configForm.baseUrl).subscribe((response) => {
      this.databaseService.deleteItemFromTable(this.examen.id,
        `examenes${(this.examen.categoriaExamen === 'periodicos'
          ? 'Periodicos'
          : 'Reevaluacion')}`);
      this.databaseService.deleteItemFromTable(this.examen.id,
        `examenes${(this.examen.categoriaExamen === 'periodicos'
          ? 'PeriodicosFiltrados'
          : 'ReevaluacionFiltrados')}`);
      this.messageAlertServices.setMessage(0, {
        severity: 'success',
        summary: '',
        detail: response.message,
        key: 'examen',
      });
      setTimeout(() => {
        this.returnToExams();
      }, 500);
      this.enviandose = false;
    },
      (error) => {
        this.formatResponseAndOpenError(error);
      }
    );
  }

  formatResponseAndOpenError(error) {
		let message = error.error.message + ' ';
		message = message + error.error.errors.map((x) => {
			return x;
		}).join(' ');
		this.openErrorAlert(message, 'examen');
	}

	private openErrorAlert(message: string, key: string): void {
		this.messageAlertServices.setMessage(0, {
			severity: 'error',
			summary: '',
			detail: message,
			key: key,
		});
		setTimeout(() => {
			const header = document.querySelector('#templateContainer') as any;
			window.scroll(0, header.offsetTop - 150);
		}, 100);
		this.enviandose = false;
	}

  private saveToOffline(): void {
    const dataToSend = this.buildRequest();
    dataToSend.fechaCarga = moment().format('yyyy-MM-DD');
    dataToSend.cargadoOffline = true;
    const details = (this.examen?.modoVista === "edit") ? 'Los cambios en el estudio fueron guardados correctamente' : 'El estudio se guardó correctamente en Por enviar';

    this.databaseService.setExameneOnExamenesPorEnviarTable(
      this.examen,
      dataToSend,
      false,
      this.examen.categoriaExamen === 'periodicos'
        ? 'Periodicos'
        : 'Reevaluacion',
      this.buildUrlApi(this.configForm.baseUrl)
    ).then((response) => {
      this.databaseService.deleteItemFromTable(this.examen.id,
        `examenes${(this.examen.categoriaExamen === 'periodicos'
          ? 'Periodicos'
          : 'Reevaluacion')}`);
      this.databaseService.deleteItemFromTable(this.examen.id,
        `examenes${(this.examen.categoriaExamen === 'periodicos'
          ? 'PeriodicosFiltrados'
          : 'ReevaluacionFiltrados')}`);
      this.backgroundSyncService.registerEvent('save-examen');
      this.messageAlertServices.setMessage(0, {
        severity: 'success',
        summary: '',
        detail: details,
        key: 'examen',
      });
      setTimeout(() => {
        this.returnToExams();
      }, 500);
    })
      .catch((e) => {
        this.messageAlertServices.setMessage(0, {
          severity: 'error',
          summary: '',
          detail:
            'Ha ocurrido un error. Por favor reintente más tarde y disculpe las molestias ocasionadas',
          key: 'examen',
        });
      });
  }

  private calculateAge(): void {
    let edad = null;
    if (this.examForm.controls.fechaNacimiento.value) {
      edad = moment().diff(
        moment(this.examForm.controls.fechaNacimiento.value),
        'years'
      );
    }
    this.examen.trabajador.edad = edad;
  }

  restrictDateIngresoEmpresa(): void {
    if(this.examForm.controls.antiguedadPuestoTrabajador.value != null && this.examForm.controls.antiguedadPuestoTrabajador.value != "") {
      this.maxDateIngreso = this.examForm.controls.antiguedadPuestoTrabajador.value;
    } else {
      this.maxDateIngreso = this.maxDate;
    }
  }

  private navigateInvalidField(classFocus: string): void {
    const invalidFields = [].slice.call(
      document.getElementsByClassName(classFocus)
    );
    const field = invalidFields[1];
    field.scrollIntoViewIfNeeded();
    field.focus();
  }

  /**
   * @description:
   * * Asignacion de valores a los campos en modo edicion
   */
  private setValuesOnFormOnVerOrEditMode(): void {
    if (this.examen?.modoVista === "edit" || this.examen.modoVista === 'ver' || this.examen?.cargadoOffline) {

      /*********************
       * * Campos del Header
       *********************/

      // *FECHA DE REALIZACION
      this.examForm.controls.fechaRealizacion.setValue(this.examen.fechaRealizacion);

      /**********************
       *  * Campos del FOOTER
       ***********************/
      this.examen.codigoDictamen = this.examen.tipoDictamen ? this.examen.tipoDictamen : this.examen.codigoDictamen;
      this.examForm.controls.codigoDictamen.setValue(this.examen.codigoDictamen);
      this.examForm.controls.medicoEspecialidad.setValue(this.examen.medicoEspecialidad);
      this.examForm.controls.matricula.setValue(this.examen.medicoMatricula);
      this.examForm.controls.medicoNombre.setValue(this.examen.medicoNombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''));

      /*********************
       * * Datos del Examen
       *********************/
      this.examForm.controls.tarea?.setValue(this.examen.tarea ? this.examen.tarea : "");
      this.examForm.controls.tiempoTarea?.setValue(this.examen.tiempoTarea ? this.examen.tiempoTarea : "");
      this.examForm.controls.sintomasRefiere?.setValue(this.examen.sintomasRefiere ? this.examen.sintomasRefiere : "");
      this.examForm.controls.peso.setValue(this.examen.peso);
      this.examForm.controls.talla.setValue(this.examen.talla);
      this.examForm.controls.indiceMasaCorporal.setValue(this.examen.indiceMasaCorporal);
      switch(this.examen.fumador) {
        case 'SI':
          this.examForm.controls.fumador.setValue(true);
          this.examForm.controls.noFumador.setValue(false);
          this.seccionTabaquismo(true);
          break;
        case 'EX':
          this.examForm.controls.exFumador.setValue(true);
          this.examForm.controls.noFumador.setValue(false);
          this.seccionTabaquismo(true);
          break;
      }
      this.examen.cantidadCigarrillos === "1a10" ? this.examForm.controls.fumaUnoDiez.setValue(true) : this.examen.cantidadCigarrillos === "11a20" ?
        this.examForm.controls.fumaOnceVeinte.setValue(true) : this.examen.cantidadCigarrillos === "Más20" ?
        this.examForm.controls.fumaMasVeinte.setValue(true) : null;
      this.examForm.controls.cantidadTiempoFumando.setValue(this.examen.cantidadTiempoFumando);
      this.examForm.controls.unidadTiempoFumando.setValue(this.examen.unidadTiempoFumando);
      this.examForm.controls.afeccionesCardiovasculares.setValue(this.examen.afeccionesCardiovasculares);
      this.examForm.controls.afeccionesCardiovascularesDescripcion?.setValue(this.examen.afeccionesCardiovascularesDescripcion ?
        this.examen.afeccionesCardiovascularesDescripcion : "");
      this.examForm.controls.afeccionesMetabolicas.setValue(this.examen.afeccionesMetabolicas);
      this.examForm.controls.afeccionesMetabolicasDescripcion?.setValue(this.examen.afeccionesMetabolicasDescripcion ?
        this.examen.afeccionesMetabolicasDescripcion : "");
      this.examForm.controls.anticonceptivosOrales.setValue(this.examen.anticonceptivosOrales);
      this.examForm.controls.embarazos.setValue(this.examen.embarazos);
      this.examForm.controls.antecedentesFamiliaresVaricopatia?.setValue(this.examen.antecedentesFamiliaresVaricopatia ?
        this.examen.antecedentesFamiliaresVaricopatia : "");
      this.examForm.controls.tratamientoMedicoActual?.setValue(this.examen.tratamientoMedicoActual ?
        this.examen.tratamientoMedicoActual : "");
      this.examForm.controls.antecedentesVaricesAnio.setValue(this.examen.antecedentesVaricesAnio);
      this.examForm.controls.varicoceleAnio.setValue(this.examen.varicoceleAnio);
      this.examForm.controls.hemorroidesAnio.setValue(this.examen.hemorroidesAnio);

      /*********************
       * * Habilitación de campos
       *********************/
      this.examen.afeccionesCardiovasculares ? this.habilitarCampo(true, "afeccionesCardiovascularesDescripcion") : null;
      this.examen.afeccionesMetabolicas ? this.habilitarCampo(true, "afeccionesMetabolicasDescripcion") : null;
      this.examen.antecedentesVarices ? this.examForm.controls.antecedentesVaricesOperada.enable() : null;
      this.examen.varicocele ? this.examForm.controls.varicoceleOperada.enable() : null;
      this.examen.hemorroides ? this.examForm.controls.hemorroidesOperada.enable() : null;
      if(this.examen.antecedentesVaricesOperada) {
        this.examForm.controls.antecedentesVaricesAnio.enable();
        this.examForm.controls.antecedentesVaricesAnio.setValidators(Validators.required);
      }
      if(this.examen.varicoceleOperada) {
        this.examForm.controls.varicoceleAnio.enable();
        this.examForm.controls.varicoceleAnio.setValidators(Validators.required);
      }
      if(this.examen.hemorroidesOperada) {
        this.examForm.controls.hemorroidesAnio.enable();
        this.examForm.controls.hemorroidesAnio.setValidators(Validators.required);
      }
    }
  }

  async onSubmit(): Promise<any> {
    this.submitted = true;
    this.validateCheckboxItems();
    this.validateCuadroVarices();
    if (this.examForm.invalid || this.invalidField || this.cuadroVaricesInvalid || this.attachedFiles.invalid || this.medicoFirmaB64 == null) {
    this.navigateInvalidField('ng-invalid');
      return;
    }
    this.enviandose = true;
    if (this.isOnline) {
      this.saveToOnline();
    } else {
      this.saveToOffline();
    }
  }

  showModalFirma(){
    this.displayModalFirma = true;
    /**
     *  Simulación de firma para desarrollo PARA GUARDAR FORMULARIO
     * Ya que no es posible utilizar el pad de firmas debemos simularla.
     * En caso de tener que desarrollar en relacion a la firma basta con
     * descomentar esta seccion de codigo y comentar 
     * this.displayModalFirma = true;
     */

     
    //this.medicoFirmaB64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';
    //this.medicoFirmaSigString = 'MOCK_SIGNATURE_' + Date.now();
    
  }

  closeModalFirma() {
    this.displayModalFirma = false;
  }

  recibirDatosFirma(datos: { firmaB64: string, firmaSigString: string }) {
    this.medicoFirmaB64 = datos.firmaB64;
    this.medicoFirmaSigString = datos.firmaSigString;
  }

  deshabilitarApellidoNombreTrabajador() {
    return this.examen.trabajador.apellidoNombre.replace(/[^a-zA-Z]/g, '').toLowerCase() !== 'alta' && this.examen.trabajador.apellidoNombre.trim().length !== 0;
  }
}
